<template>
    <div>
        <div class="container" v-show="postData.post_enc_id">
            <div class="row">
                <div class="col-md-8">
                    <div class="video-box-main dash-inner-box">
                        <div class="rec-batch" v-if="postData.is_recommended">Recommended</div>
                        <div class="vid-box" v-html="postData.frame"
                             v-if="postData.content_type == 'Video' || postData.content_type == 'Audio' || postData.content_type == 'Podcast'"></div>
                        <div class="vid-box" v-else>
                            <img v-if="postData.cover_image" :src="postData.cover_image"/>
                            <img v-else :src="postData.post_image_url"/>
                        </div>
                        <h3>{{ postData.post_title }}</h3>
                        <div class="like-dis">
                            <a href="javascript:;" class="like-btn default" title="Like"
                               :data-key="postData.post_enc_id" @click="likeThisPost($event,1)"
                               v-if="postData.feedback_status == 0"><i class="fa fa-thumbs-up"></i></a>
                            <a href="javascript:;" class="like-btn" title="Like"
                               :data-key="postData.post_enc_id" @click="likeThisPost($event,0)"
                               v-if="postData.feedback_status == 1"><i class="fa fa-thumbs-up"></i></a>
                            <div v-if="postData && postData.recommended_by && postData.recommended_by.length"
                                 class="list-data margin-top-10">
                                <strong>Recommended By:- &nbsp;</strong>
                                <span
                                    v-for="pr in postData.recommended_by"> {{ pr.first_name }} {{ pr.last_name }}</span>
                            </div>
                        </div>
                        <div class="author-s margin-top-10">
                            <div class="author list-data"
                                 v-if="postData && postData.skillsUpAuthors && postData.skillsUpAuthors.length"><i
                                class="fas fa-user"></i><span v-for="au in postData.skillsUpAuthors"> {{
                                    au.name
                                }}</span></div>
                            <div class="source"><i class="fas fa-link"></i><span> {{ postData.source_name }}</span>
                            </div>
                            <div class="author list-data" v-if="postData.price"><i class="fas fa-money-bill-alt"></i>
                                {{ postData.currency }} {{ postData.price }}
                            </div>
                        </div>
                        <div class="tags-list"
                             v-if="postData && postData.skillsUpPostAssignedSkills && postData.skillsUpPostAssignedSkills.length">
                            <h5 class="tag-title">Related Topic</h5> :- <span
                            v-for="sList in postData.skillsUpPostAssignedSkills">{{ sList.skill }}</span>
                        </div>
                        <div class="vid-content" v-html="postData.post_description">

                        </div>
                        <div class="original-art">
                            <a href="javascript:;" class="recommend-student" title="Recommend To Students"
                               v-if="this.$store.getters.getUserType == 'teacher' && !postData.teacher_recommended"
                               @click="recommendToStudent($event)" :data-key="postData.post_enc_id">RECOMMEND TO
                                STUDENTS</a>
                            <a href="javascript:;" class="recommend-student" title="Recommended To Students"
                               v-if="this.$store.getters.getUserType == 'teacher' && postData.teacher_recommended"
                               @click="recommendToStudent($event)" :data-key="postData.post_enc_id">RECOMMENDED TO
                                STUDENTS</a>
                            <a :href="postData.post_source_url" target="_blank"
                               v-if="postData.content_type != 'Course' && postData.post_source_url">View ORIGINAL
                                {{ postData.content_type }}</a>
                            <a :href="postData.course_url" target="_blank" v-else-if="postData.course_url">READ ORIGINAL
                                {{ postData.content_type }}</a>
                        </div>
                        <div class="share-social-links">
                            <a href="javascript:;" class="fb"
                               onclick="window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-facebook-f"></i></a>
                            <a href="javascript:;" class="wts-app"
                               onclick="window.open('https://api.whatsapp.com/send?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-whatsapp"></i></a>
                            <a href="javascript:;" class="tw"
                               onclick="window.open('https://twitter.com/intent/tweet?text=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-twitter"></i></a>
                            <a :href="'mailto:https://myecampus.in'+this.$route.fullPath" class="male">
                                <i class="far fa-envelope"></i></a>
                            <a href="javascript:;" class="fb"
                               onclick="window.open('https://www.linkedin.com/shareArticle?mini=true&amp;url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-linkedin"></i></a>
<!--                            <a href="javascript:;" class="male"-->
<!--                               onclick="window.open('http://pinterest.com/pin/create/link/?url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">-->
<!--                                <i class="fab fa-pinterest"></i></a>-->
                            <a href="javascript:;" class="tw"
                               onclick="window.open('https://telegram.me/share/url?url=' + window.location.href, '_blank', 'width=800,height=400,left=200,top=100');">
                                <i class="fab fa-telegram"></i></a>
                            <a href="javascript:;" class="male" title="Share in Chat" @click="sendPostInChat()">
                                <i class="far fa-comment-dots"></i>
                            </a>
                        </div>
                        <div class="discussion-box">
                            <h3>Comments</h3>
                            <div
                                v-if="this.$store.getters.getUserType == 'teacher' || this.$store.getters.getUser['user_type'] == 'Individual'">
                                <textarea class="form-control" id="skill-comment-val"></textarea>
                                <div class="text-right">
                                    <button class="cmnt-btn" @click="sendComment()">Comment</button>
                                </div>
                            </div>
                        </div>
                        <div class="show-comment">
                            <ul id="skill-up-comments-list" class="comments-list comments-main">

                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="live-chat dash-inner-box">
                        <h3>Chatting</h3>
                        <div id="skillup-chat-main" class="chatting-live">

                        </div>
                        <div class="input-chat"
                             v-if="this.$store.getters.getUserType == 'teacher' || this.$store.getters.getUser['user_type'] == 'Individual'">
                            <textarea type="text" class="form-control" id="chat-value"></textarea>
                            <a href="javascript:;" @click="sendChatMessage()">Send</a>
                        </div>
                    </div>
                    <div class="related-art dash-inner-box" v-if="related_posts && related_posts.length">
                        <h3>Related Articles</h3>
                        <a :href="'/dashboard/skill-up-detail?id=' + rp.post_enc_id" class="relate-box"
                           v-for="rp in related_posts">
                            <div class="relate-icon">
                                <img :src="rp.cover_image" v-if="rp.cover_image">
                                <img :src="rp.post_image_url" v-else-if="rp.post_image_url">
                            </div>
                            <div class="relate-name">
                                <p v-html="rp.post_title"></p>
                                <div class="author-relate">
                                    <!--                                    <div class="author list-data" v-if="rp.skillsUpAuthors.length"><i class="fas fa-user"></i><span v-for="au in rp.skillsUpAuthors"> {{ au.name }}</span></div>-->
                                    <div class="source"><i class="fas fa-link"></i><Span> {{ rp.source_name }}</Span>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 margin-top-40 padd-top-50" v-show="!postData.post_enc_id">
            <div id="sectionIsLoading" class="sectionIsLoading">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import toastr from "../../../public/js/toastr";
import firebase from "firebase";
import {requestHeaders} from "../../_helpers/apiHelper";

export default {
    data: function () {
        return {
            postData: [],
            monthDict: {
                0: 'Jan',
                1: 'Feb',
                2: 'Mar',
                3: 'Apr',
                4: 'May',
                5: 'June',
                6: 'July',
                7: 'Aug',
                8: 'Sep',
                9: 'Oct',
                10: 'Nov',
                11: 'Dec',
            },
            specialKey: 'BnE3860mWdnBEZMLXlwkdjw9A2K5DJ',
            db: firebase.database(),
            ref: '',
            related_posts: [],
            userImage: "",
        }
    },
    mounted() {
        if (!this.$store.getters.getUser['has_skillup_featured']) {
            this.$router.push({path: '/dashboard'});
            return false;
        }
        this.getPostDetail();
        var t = this;
        var db = firebase.database();
        var ref = db.ref(t.specialKey + '/skillUp/comments/' + t.$route.query.id + '/' + t.$store.getters.getUser['college_enc_id']);
        ref.on('value', gotData, errData);

        function gotData(data) {
            var result2 = [];
            for (var i in data.val()) {
                result2.push([i, data.val()[i], data.val()[i].timestamp]);
            }
            if (result2.length) {
                result2.sort(function (a, b) {
                    return a[2] - b[2];
                });
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to == "") {
                            t.showComment(result2[z][1].is_public, result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to != "") {
                            t.showReply(result2[z][0], result2[z][1].reply_to, result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
            }
        }

        function errData(data) {
            console.log('err');
        }

        var chatRef = db.ref(t.specialKey + '/skillUp/chat/' + t.$store.getters.getUser['college_enc_id']);
        chatRef.on('value', gotData2, errData2);

        function gotData2(data) {
            var result2 = [];
            for (var i in data.val()) {
                result2.push([i, data.val()[i], data.val()[i].timestamp]);
            }
            if (result2.length) {
                result2.sort(function (a, b) {
                    return a[2] - b[2];
                });
                for (var z = 0; z < result2.length; z++) {
                    if (!document.getElementById(result2[z][0])) {
                        if (result2[z][1].reply_to == "") {
                            t.showChatMessage(result2[z][0], result2[z][1].name, result2[z][1].comment, result2[z][1].date + " " + result2[z][1].time, result2[z][1].image);
                        }
                    }
                }
            }
        }

        function errData2(data) {
            console.log('err');
        }

        t.initializeEvents();
        // let messageText = document.getElementById('chat-value');
        // if (messageText) {
        //     messageText.addEventListener('keyup', function (event) {
        //         if (event.keyCode === 13) {
        //             event.preventDefault();
        //             t.sendChatMessage();
        //         }
        //     });
        // }
        if (t.$store.getters.getUser['image']) {
            t.userImage = t.$store.getters.getUser['image'];
        } else {
            let str = t.$store.getters.getUser['initials_color'];
            str = str.substring(1);
            t.userImage = 'https://ui-avatars.com/api/?name=' + t.$store.getters.getUser['first_name'] + '+' + t.$store.getters.getUser['last_name'] + '&background=' + str + '&color=fff';
        }
    },
    methods: {
        sendPostInChat(){
            document.getElementById('chat-value').value = window.location.href;
        },
        getPostDetail() {
            var t = this;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/skill-up/post-detail`, {post_id: t.$route.query.id}, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    t.postData = response['data']['response']['data'];
                    t.related_posts = response['data']['response']['related_posts'];
                    setTimeout(function () {
                        $('#skill-up-comments-list').perfectScrollbar();
                        $('#skillup-chat-main').perfectScrollbar();
                    }, 1500)
                } else if (response['data']['response']['status'] == 404) {
                    alert('Post Not Found!');
                    t.$router.go(-1);
                } else {
                    alert('Unstable internet connection or an error occurred!');
                    window.location.replace("/");
                }
            });
        },
        sendComment() {
            var t = this;
            var currentDate = new Date();
            var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
            var getMins = currentDate.getMinutes();
            if (getMins < 10) {
                getMins = "0" + getMins;
            }
            var sendtime = currentDate.getHours() + ":" + getMins;
            var ques = document.getElementById('skill-comment-val').value;
            if (ques != '') {
                var uId = t.uniqueId();
                var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
                var ref = t.db.ref(t.specialKey + '/skillUp/comments/' + t.$route.query.id + '/' + t.$store.getters.getUser['college_enc_id'] + '/' + uId);
                ref.set({
                    'name': name,
                    'sender': t.$store.getters.getUser['user_id'],
                    'is_public': true,
                    'reply_to': "",
                    'comment': ques,
                    'image': t.userImage,
                    'date': senddate,
                    'time': sendtime,
                    'timestamp': Date.now(),
                });
                t.saveComment(uId, ques);
                document.getElementById('skill-comment-val').value = "";
            } else {
                alert('Enter Comment to send');
            }
        },
        likeThisPost(event, action) {
            var t = this;
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            t.postData.feedback_status = action;
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/skill-up/post-like-dislike`, {
                post_id: data_key,
                action: action
            }, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] != 200) {
                    var tempData;
                    if (action == 1) {
                        tempData = 0;
                    } else {
                        tempData = 1
                    }
                    t.postData.feedback_status = tempData;
                }
            });
        },
        sendChatMessage() {
            var t = this;
            var currentDate = new Date();
            var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
            var getMins = currentDate.getMinutes();
            if (getMins < 10) {
                getMins = "0" + getMins;
            }
            var sendtime = currentDate.getHours() + ":" + getMins;
            var ques = document.getElementById('chat-value').value;
            if (ques != '') {
                var uId = t.uniqueId();
                var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
                var ref = t.db.ref(t.specialKey + '/skillUp/chat/' + t.$store.getters.getUser['college_enc_id'] + '/' + uId);
                ref.set({
                    'name': name,
                    'sender': t.$store.getters.getUser['user_id'],
                    'is_public': true,
                    'reply_to': "",
                    'comment': ques.trim(),
                    'image': t.userImage,
                    'date': senddate,
                    'time': sendtime,
                    'timestamp': Date.now(),
                });
                document.getElementById('chat-value').value = "";
                document.getElementById('skillup-chat-main').scrollTop = document.getElementById('skillup-chat-main').scrollHeight;
            } else {
                alert('Enter Message to send');
            }
        },
        sendReply(message, id) {
            var t = this;
            var currentDate = new Date();
            var senddate = currentDate.getDate() + " " + t.monthDict[currentDate.getMonth()] + " " + currentDate.getFullYear();
            var getMins = currentDate.getMinutes();
            if (getMins < 10) {
                getMins = "0" + getMins;
            }
            var sendtime = currentDate.getHours() + ":" + getMins;
            var uId = t.uniqueId();
            var name = this.$store.getters.getUser['first_name'] + ' ' + this.$store.getters.getUser['last_name'];
            var ref = t.db.ref(t.specialKey + '/skillUp/comments/' + t.$route.query.id + '/' + t.$store.getters.getUser['college_enc_id'] + '/' + uId);
            ref.set({
                'name': name,
                'sender': t.$store.getters.getUser['user_id'],
                'reply_to': id,
                'comment': message,
                'image': t.userImage,
                'date': senddate,
                'time': sendtime,
                'timestamp': Date.now(),
            });
            t.saveComment(uId, message, id);
        },
        showComment(visibility, id, name, message, date, image) {
            message = message.replace(/\n\s*\n/g, '\n');
            var template;
            if (this.$store.getters.getUserType == 'teacher' || this.$store.getters.getUser['user_type'] == 'Individual') {
                template = '<li id="' + id + '" data-key="' + id + '"><div class="comment-main-level"><div class="comment-avatar"><img src="' + image + '" alt=""></div><div class="comment-box"><div class="comment-head"><h6 class="comment-name"><a href="javascript:;">' + name + '</a></h6><span class="posted-time">Posted on ' + date + '</span></div><div class="comment-content">' + message.replace(/\n/g, '<br />') + '<div class="comment-open"><a class="btn-reply">Reply</a></div></div><div class="comment-footer"><div class="comment-form"><textarea class="form-control" name=""></textarea><div class="pull-right send-button"><a class="btn-send send-reply">Send</a></div></div></div></div></div><ul class="comments-list quieries reply-list"></ul></li>';
            } else {
                template = '<li id="' + id + '" data-key="' + id + '"><div class="comment-main-level"><div class="comment-avatar"><img src="' + image + '" alt=""></div><div class="comment-box"><div class="comment-head"><h6 class="comment-name"><a href="javascript:;">' + name + '</a></h6><span class="posted-time">Posted on ' + date + '</span></div><div class="comment-content">' + message.replace(/\n/g, '<br />') + '</div></div></div><ul class="comments-list quieries reply-list"></ul></li>';
            }
            document.getElementById('skill-up-comments-list').insertAdjacentHTML("beforeend", template);
        },
        showChatMessage(id, name, message, date, image) {
            message = message.replace(/\n\s*\n/g, '\n');
            var template = '<div id=' + id + ' class="chat-person"> <img src="' + image + '"> <p><span>' + name + '</span>' + message.replace(/\n/g, '<br />') + '</p> </div>';
            document.getElementById('skillup-chat-main').insertAdjacentHTML("beforeend", template);
        },
        showReply(id, parent, name, message, date, image) {
            message = message.replace(/\n\s*\n/g, '\n');
            var template = '<li id="' + id + '"><div class="comment-avatar"><img src="' + image + '"></div> <div class="comment-box"> <div class="comment-head"><h6 class="comment-name"><a href="javascript:;">' + name + '</a></h6> <span class="posted-time">Posted on ' + date + '</span> </div> <div class="comment-content"> ' + message.replace(/\n/g, '<br />') + '</div> </div> </li>';
            document.getElementById(parent).childNodes[1].insertAdjacentHTML("beforeend", template);
        },
        initializeEvents() {
            var t = this;
            $(document).on('click', '.btn-reply', function (eve) {
                eve.preventDefault();
                $(this).parent().parent().siblings('.comment-footer').slideToggle();
                eve.stopImmediatePropagation();
            });
            $(document).on('click', '.send-reply', function (eve) {
                eve.preventDefault();
                var targetObject = $(this).parent().parent().parent().parent().parent();
                var textarea = $(this).parent().siblings('textarea');
                var reply_text = $(this).parent().siblings('textarea').val();
                if ($.trim(reply_text) == " " || $.trim(reply_text) == "") {
                    alert("insert comment");
                } else {
                    if ($(targetObject).hasClass("comment-main-level")) {
                        if ($(targetObject).siblings('.comments-list.quieries.reply-list')) {
                            var r_id = $(targetObject).parent('li').attr('id');
                            textarea.val('');
                            t.sendReply(reply_text, r_id);
                        }
                    }
                }
            });
            $(document).on('click', '.move-to-comments', function (e) {
                e.preventDefault();
                var id = $(this).parentsUntil('li').parent('li').attr('id');
                t.moveToComments(id);
            });
        },
        uniqueId() {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < 15; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return this.$store.getters.getUser['user_id'] + result;
        },
        recommendToStudent(event) {
            var t = this;
            var element = event.currentTarget;
            var data_key = element.getAttribute('data-key');
            if (t.postData.teacher_recommended) {
                t.postData.teacher_recommended = false;
            } else {
                t.postData.teacher_recommended = true
            }
            var url = this.$store.getters.getDomain;

            axios.post(`${url}api/v2/skill-up/save-recommended-post`, {
                post_id: data_key,
            }, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] != 200) {
                    if (t.postData.teacher_recommended) {
                        t.postData.teacher_recommended = false;
                    } else {
                        t.postData.teacher_recommended = true
                    }
                }
            });
        },
        saveComment(id, comment, reply_to = null) {
            var t = this;
            var url = this.$store.getters.getDomain;

            var data = {'post_id': t.$route.query.id, 'id': id, 'comment': comment}
            if (reply_to) {
                data['reply_to'] = reply_to;
            }
            axios.post(`${url}api/v2/skill-up/post-comments`, data, {headers: requestHeaders()}).then(function (response) {
                if (response['data']['response']['status'] == 200) {
                    // toastr.success('Comment Sended', 'Success');
                } else {
                    toastr.error('An Error Occurred Try Again', 'Oops!!');
                }
            });
        },
        loaderShow() {
            var fadeTarget = document.getElementById("h-page-loading");
            var fadeEffect = setInterval(function () {
                if (!fadeTarget.style.opacity) {
                    fadeTarget.style.opacity = 0;
                }
                if (fadeTarget.style.opacity == 0) {
                    fadeTarget.style.opacity = 0.7;
                } else {
                    clearInterval(fadeEffect);
                    fadeTarget.style.display = "block";
                }
            }, 100);
        },
        loaderHide() {
            var fadeTarget = document.getElementById("h-page-loading");
            var fadeEffect = setInterval(function () {
                if (!fadeTarget.style.opacity) {
                    fadeTarget.style.opacity = 1;
                }
                if (fadeTarget.style.opacity > 0) {
                    fadeTarget.style.opacity -= 0.1;
                } else {
                    clearInterval(fadeEffect);
                    fadeTarget.style.display = "none";
                }
            }, 100);
        },
    },
}
</script>

<style scoped>
.video-box-main {
    padding: 20px;
    margin-bottom: 20px;
    position: relative;
}

.rec-batch {
    position: absolute;
    right: 25px;
    top: 25px;
    background-color: #fff;
    padding: 5px 8px;
    font-family: roboto;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 500;
}

.vid-box img {
    width: 100%;
    height: 100%;
    max-height: 450px;
    object-fit: cover;
}

.video-box-main h3 {
    font-size: 22px;
    font-family: roboto;
    margin-top: 20px;
}

.author-s {
    display: flex;
    align-items: center;
    font-family: roboto;
}

.author, .source {
    margin-right: 10px;
    color: #fff;
    padding: 4px 8px;
    margin-bottom: 10px;
}

.author {
    background-color: #00a0e3;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 19px;
    height: 24.8px;
}

.source {
    background-color: #ff7803;
    flex: none;
}

.vid-content {
    font-size: 14px;
    text-align: justify;
    line-height: 22px;
    font-family: roboto;
}

.original-art a {
    background-color: #00a0e3;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    padding: 10px 16px;
    display: inline-block;
    font-family: roboto;
    font-weight: 500;
    margin: 15px 5px 0 0;
    text-transform: uppercase;
}

.share-social-links {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
}

.share-social-links > a {
    min-width: 90px;
    margin: 15px 1% 0 0;
}

.share-social-links > a:last-child {
    margin-right: 0;
}

.wts-app {
    background-color: #25D366;
}

.male {
    background-color: #d3252b;
}

.tw {
    background-color: #1c99e9;
}

.fb {
    background-color: #236dce;
}

.wts-app i, .male i, .tw i, .fb i {
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    width: 100%;
    text-align: center;
    padding: 10px 0;
}

.discussion-box textarea {
    padding: 10px;
    font-family: roboto;
}

.cmnt-btn {
    color: #fff;
    background-color: #00a0e3;
    border: none;
    font-family: roboto;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 15px;
    margin: 10px 0 0;
    display: inline-block;
    width: 100px;
}

.show-comment {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin: 20px 0;
}

.user-p {
    width: 60px;
    height: 60px;
    margin-right: 20px;
}

.user-p img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.user-name-c {
    border-left: 2px solid #eee;
    padding-left: 20px;
    font-family: roboto;
    flex-basis: 75%;
    text-align: justify;
}

.user-name-c h3 {
    font-size: 22px;
    margin-top: 0px !important;
}

.reply-comment {
    flex-basis: 10%;
    text-align: center;
}

.reply-comment button {
    color: #ff7803;
    background-color: #fff;
    border: none;
    font-family: roboto;
}

.live-chat {
    height: 515px;
    position: relative;
    overflow: hidden;
}

.chatting-live {
    height: 365px;
    position: relative;
    overflow: hidden;
}

.input-chat {
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}

.input-chat a {
    position: absolute;
    right: 0;
    top: 0;
    background-color: #00a0e3;
    padding: 12px 18px;
    color: #fff;
    font-family: roboto;
    font-weight: 500;
}

.related-art, .live-chat {
    padding: 20px;
    margin-bottom: 20px;
}

.related-art h3, .live-chat h3 {
    margin: 0;
    margin-bottom: 20px;
    color: #00a0e3;
    font-family: roboto;
    font-size: 22px;
}

.relate-box {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 15px;
}

.relate-box:last-child {
    margin-bottom: 0;
}

.relate-icon {
    width: 90px;
    height: 90px;
    margin-right: 10px;
}

.relate-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-width: 90px;
}

.relate-name p {
    font-size: 14px;
    font-family: roboto;
    line-height: 18px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 5px;
    cursor: pointer;
}

.author-relate {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
}

.author-relate span {
    margin-right: 10px;
}

.save-later {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dis-none {
    opacity: 0;
    transition: ease-in-out .3s;
}

.relate-box:hover .dis-none {
    opacity: 1;
}

.author-relate > div {
    margin-bottom: 5px;
}

.like-btn {
    color: #00a0e3;
    font-size: 20px;
}

.like-btn.default {
    color: #aaa;
}

#chat-value {
    width: calc(100% - 70px);
    padding: 0px 10px;
    height: 40px;
}

.tags-list span {
    background-color: #eee;
    padding: 7px 15px;
    border-radius: 15px;
    margin: 0px 5px;
}

.tag-title {
    display: inline-block;
    color: #00a0e3;
    font-weight: 550;
    font-size: 18px;
}

.margin-top-10 {
    margin-top: 10px;
}

.share-social-links:hover a {
    opacity: 0.6;
}

.share-social-links > a:hover {
    opacity: 1;
}

</style>